import { render, staticRenderFns } from "./SigninCard.vue?vue&type=template&id=08d4c5b6"
import script from "./SigninCard.vue?vue&type=script&lang=js"
export * from "./SigninCard.vue?vue&type=script&lang=js"
import style0 from "./SigninCard.vue?vue&type=style&index=0&id=08d4c5b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports